import { render, staticRenderFns } from "./selectZGLX.vue?vue&type=template&id=7c63f46c"
import script from "./selectZGLX.vue?vue&type=script&lang=js"
export * from "./selectZGLX.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports